import { render } from "./IconOCR.vue?vue&type=template&id=2ecb05a4"
import script from "./IconOCR.vue?vue&type=script&lang=ts"
export * from "./IconOCR.vue?vue&type=script&lang=ts"
script.render = render

export default script